export default "__VITE_ASSET__XaCbkU1v__"